/**
 * File: skipToMain.js.
 *
 * Import and initialize functions for Skip to Main content functionality
 */

 export default {
  header: document.querySelector('[data-elementor-type="header"]'),
  mainContent: document.querySelector('[data-elementor-type="header"]').nextElementSibling,
  body: document.querySelector('body'),
  init() {
    if (this.header && this.header) {
        this.render();
    }
  },
  render() {
    // insert the skip to main content
    let skipToMainElement = document.createElement('a');
    skipToMainElement.className = "skip-link screen-reader-text";
    skipToMainElement.href = "#main";
    skipToMainElement.innerHTML = "Skip to content"
    this.body.prepend(skipToMainElement);
    this.mainContent.setAttribute('id', 'main');
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
